export default {
    1:[
        2905, 61875, 61881, 61882, 61872, 61883, 61732, 63343, 61836, 61866,  
        59147, 59142, 59143, 59132, 59133, 61413, 62297, 59126, 59127, 61435,
        61840, 59144, 59145, 61884, 59146, 20144, 20232,
    ],
    2:[
        19738, 19933, 40438, 20145, 20138, 61869, 2891, 61066,
        21018, 21008, 21041, 20898, 19676, 18994, 20311,61063,
        20744, 20894, 21499, 2905, 20170, 20144, 20152, 61060, 2903,
        21045, 19660, 61331, 19740, 20903, 59131, 59139, 59138, 61866,
        20904, 20915, 20905, 20165, 20137, 20142, 2832, 59137, 59143,
        61876, 34575, 19661, 59127, 59133, 62340, 59129, 59134, 61065,
        61344, 61340, 61338, 61335, 61434, 61439, 61431, 56752, 63532, 
        19932, 63837, 63838, 63439, 63804, 63438, 63521, 21301, 63866,
        56421, 58925, 20943, 21035, 20997, 21499, 20894, 20942, 20502,
        20744, 20916, 21344, 20311, 20917, 18994, 20930, 21041, 55547,
        61533, 61534, 61431, 56475, 61430, 56476,

    ],
    3:[
        21012, 21344, 19663 , 20905 , 21347, 21905, 61935, 21929, 21930, 
        1885, 58925, 39286, 59001, 58918, 2863, 55589, 61729, 2913,
        2914, 63863, 61327, 20891, 61839, 61867, 55678, 2888, 57093,
        59807, 59808, 61367, 56617, 2891, 56424, 20866, 20960, 56992,
        20160, 59852, 57719, 57764, 61303, 61248, 60724, 61204, 60086,
        60098, 61406, 63511, 61068, 61134, 61091, 62917, 20964, 19660,
        20588, 20905, 64595,
    ],
//   4:[],
//   5:[]
}
